// extracted by mini-css-extract-plugin
module.exports = {"PageTop":"Page_PageTop__SZPab","Title":"Page_Title__O_3Eh"};